import { render, staticRenderFns } from "./ShippingsByDirection.vue?vue&type=template&id=3b612a44"
import script from "./ShippingsByDirection.vue?vue&type=script&lang=js"
export * from "./ShippingsByDirection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports